export * from './datasHero'
export * from './datasTable'
export * from './designHero'
export * from './doubleImage'
export * from './galleryViewer'
export * from './handwriteImage'
export * from './largeQuote'
export * from './lifestyleHero'
export * from './nextSection'
export * from './singleImage'
export * from './singleParagraph'
